// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCalipers, iconCalipersTag } from '@ni/nimble-components/dist/esm/icons/calipers';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCalipers };
export { iconCalipersTag };
export const NimbleIconCalipers = wrap(IconCalipers);